import { lastWord } from './string';

export const DAZN_LOGO_URL = 'https://cdn.upshow.tv/ui-assets/DAZNForBusiness-Inline-White.png';

// Above this many characters (both names together) each team shows only its last word.
const MAX_FULL_NAMES_LENGTH = 30;

// Names to show for a matchup, e.g. "Chiefs @ Bills" when "Kansas City Chiefs @ Buffalo Bills" would be too long.
export function getMatchupLabels(firstTeam, secondTeam) {
    const lastWordOnly = firstTeam.display_name.length + secondTeam.display_name.length > MAX_FULL_NAMES_LENGTH;
    return {
        firstLabel: (lastWordOnly ? lastWord(firstTeam.display_name) : firstTeam.display_name) || '',
        secondLabel: (lastWordOnly ? lastWord(secondTeam.display_name) : secondTeam.display_name) || '',
    };
}
